export const SEND_MESSAGE = 'sendMessage'
export const JOIN_ROOM = 'join-room'
export const NEW_CONVERSATION = 'join-help-desk'